export const getStagedLoanAppTemplate = state => state.v2.loanAppTemplates.stagedRecord
